<template>
  <div class="home-page">
    <div class="header">
      <h1 class="page-title">建设项目环境影响评价拟审批公示的告知事项</h1>
    </div>

    <div class="content-container">
      <div class="declaration-content">
        <!-- 声明内容 -->
        <div class="declaration-section">
          <ol class="declaration-list">
            <li class="declaration-item">
              上海市奉贤区生态环境局按照《中华人民共和国环境影响评价法》、《行政许可法》、《信息公开条例》以及相关法规、规章和规定的要求，公示建设项目环境影响评价行政许可受理信息。
            </li>
            <li class="declaration-item">
              受理信息公示时限：环境影响评价报告书自信息发布起10个工作日，环境影响评价报告表自信息发布起5个工作日。
            </li>
            <li class="declaration-item">
              公示期间，公众（包括个人、团体等）可以通过电子邮件或信函（以邮戳为准）方式提出意见。
              <div>电子邮件：fxqsthjjhpk2020@163.com。</div>
              <div>
                信函请寄至：上海市奉贤区奉浦街道环城东路383号丽洲大厦19楼1905室，上海市奉贤区生态环境局
                行政许可科 收（邮编：201499）。请在信封上注明：对XXX
                （建设项目）的意见。
              </div>
            </li>
            <li class="declaration-item">
              依据《中华人民共和国行政许可法》第四十七条，行政许可直接涉及申请人与他人之间重大利益关系的，行政机关在作出行政许可决定前，申请人、利害关系人享有要求听证的权利，自拟审批公示起五日内申请人、利害关系人可对拟作出的建设项目环境影响评价文件审批意见要求听证。
            </li>
            <li class="declaration-item">
              相关资料由外界所提供、并以行政许可申请人所提交的形式进行公开。上述资料和信息中如有错漏，使用上述信息和资料作为依据者自行承担责任。
            </li>
          </ol>
        </div>
        <!-- 阅读确认 -->
        <div class="agree-section">
          <el-checkbox v-model="hasAgreed" class="agree-checkbox">
            我已阅读并同意以上内容
          </el-checkbox>
        </div>
        <!-- 确认按钮 -->
        <div class="confirm-section">
          <el-button
            type="primary"
            size="large"
            @click="handleConfirm"
            class="confirm-button"
          >
            确认
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Public",
  data() {
    return {
      hasAgreed: false,
    };
  },
  methods: {
    handleConfirm() {
      // 检查是否已阅读
      if (!this.hasAgreed) {
        this.$message({
          showClose: true,
          message: "请勾选我已阅知",
          type: "warning",
        });
        return;
      }
      // 跳转到介绍页面
      this.$router.push("/publicLogin");
    },
  },
};
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
}

.header {
  background: white;
  padding: 30px 20px;
  border-bottom: 1px solid #e4e7ed;
  position: relative;
  z-index: 10;
}

.page-title {
  text-align: center;
  margin: 0;
  color: #303133;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 1px;
}

.content-container {
  flex: 1;
  padding: 40px 20px;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}

.declaration-content {
  background: white;
  width: 100%;
  /* max-width: 800px; */
}

.declaration-section {
  margin-bottom: 40px;
}

.declaration-list {
  padding-left: 24px;
  margin: 0;
}

.declaration-item {
  font-size: 16px;
  /* line-height: 1.8; */
  color: #606266;
  margin-bottom: 5px;
  text-align: justify;
  padding: 8px 0;
}

.declaration-item:last-child {
  margin-bottom: 0;
}

.confirm-section {
  text-align: center;
  padding: 30px 0 10px;
  border-top: 1px solid #e4e7ed;
  margin-top: 30px;
}

.confirm-button {
  padding: 12px 60px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 6px;
  background: #409eff;
  border: none;
  transition: all 0.3s ease;
}

.confirm-button:hover {
  background: #66b1ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 20px 15px;
  }

  .page-title {
    font-size: 22px;
  }

  .content-container {
    padding: 30px 15px;
  }

  .declaration-item {
    font-size: 15px;
    line-height: 1.6;
  }

  .confirm-button {
    width: 100%;
    max-width: 200px;
    padding: 12px 20px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .declaration-item {
    font-size: 14px;
  }

  .confirm-button {
    font-size: 16px;
  }
}

/* 打印样式 */
@media print {
  .confirm-section {
    display: none;
  }

  .home-page {
    background: white;
  }
}
</style>
